import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import Logo from "../assets/images/logo.svg";
import { setSearch } from "../features/api/Search/searchSlice";

export default function Navbar() {
  const dispatch = useDispatch();
  const [newSearch, setNewSearch] = useState("");

  const handleChange = (e) => {
    if (e.key === "Enter") {
      dispatch(setSearch(newSearch));
    } else if (newSearch === "" && e.keyCode === 8) {
      dispatch(setSearch(""));
    }
  };
  return (
    <nav className="container relative py-3">
      <div className="flex items-center justify-between">
        <Link to="/">
          <img src={Logo} alt="Logo" />
        </Link>
        <div className="flex-1 max-w-xs search-field group">
          <i className="fa-solid fa-magnifying-glass search-icon group-focus-within:text-blue-500"></i>
          <input
            type="text"
            placeholder="Search Task"
            className="search-input"
            id="lws-searchTask"
            value={newSearch}
            onChange={(e) => setNewSearch(e.target.value)}
            onKeyDown={(e) => handleChange(e)}
          />
        </div>
      </div>
    </nav>
  );
}
